import {MoreHoriz, MoreVert} from "@mui/icons-material";
import {IconButton, List, ListItemButton, ListItemText, Popover} from "@mui/material";
import {useEffect, useState} from "react";
import APXConfirmationDialog from "./APXConfirmationDialog.jsx";


export function useCurrentSelectedOption({item = null, option = null}: { item?: any, option?: APXBaseOption }):
		  { currentItem: any, setCurrentItem: any, currentOption: any, setCurrentOption: any, showBottomSheet: boolean, setShowBottomSheet: any, } {
	  const [currentItem, setCurrentItem] = useState(item);
	  const [currentOption, setCurrentOption] = useState(option);
	  const [showBottomSheet, setShowBottomSheet] = useState(false);
	  
	  const setCurrentOptionAndDoOnClick = (option: APXBaseOption) => {
			 setCurrentOption(option);
			 if (/*TRUTHY->*/ !!option) {
					option.onClick();
			 }
	  };
	  
	  
	  useEffect(() => {
			 if (currentItem && currentOption) {
					// currentOption.onClick();
					setCurrentOption(null);
			 }
	  }, [currentOption]);
	  
	  return {
			 currentItem, setCurrentItem, currentOption, setCurrentOption,
			 showBottomSheet, setShowBottomSheet
	  };
}


export type APXBaseOption = {
	  label: string;
	  needsConfirmation: boolean;
	  keepDisabled: boolean;
	  onClick: () => void;
}


export type APXOptions = {
	  [optionName: string]: APXBaseOption;
}


export interface APXMoreMenuProps {
	  options: APXOptions;
	  onConfirmedOptionSelected: (selectedOption: APXBaseOption) => {};
	  disabled?: boolean;
	  iconVertical?: boolean;
}


export default function APXMoreMenuWithPopover({options, iconVertical = true, disabled = false, onConfirmedOptionSelected}: APXMoreMenuProps) {
	  const [anchorEl, setAnchorEl] = useState(null);
	  
	  const handleClick = (event) => {
			 setAnchorEl(event.currentTarget);
	  };
	  
	  const handleClose = () => {
			 setAnchorEl(null);
	  };
	  
	  const open = Boolean(anchorEl);
	  
	  const [tempCurrentOptionForConfirmation, setTempCurrentOptionForConfirmation] = useState(null);
	  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
	  
	  return (
				 <>
						<IconButton size={"small"} disabled={disabled} onClick={handleClick}>{iconVertical ? <MoreVert/> : <MoreHoriz/>}</IconButton>
						<Popover open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{vertical: "bottom", horizontal: "center"}}
									transformOrigin={{vertical: "top", horizontal: "right"}}>
							  <List dense onClick={handleClose}>
									 {
											Object.keys(options).map((option) => {
												  return (
															 <ListItemButton key={option}
																				  disabled={options[option].keepDisabled}
																				  onClick={() => {
																						 if (options[option].needsConfirmation) {
																								setTempCurrentOptionForConfirmation(options[option]);
																								setShowConfirmationDialog(true);
																						 } else {
																								onConfirmedOptionSelected(options[option]);
																						 }
																				  }}
															 >
																	<ListItemText primary={options[option].label}/>
															 </ListItemButton>
												  );
											})
									 }
							  </List>
						</Popover>
						{showConfirmationDialog &&
								  <APXConfirmationDialog onClose={() => setShowConfirmationDialog(false)}
																 onConfirmed={() => {
																		onConfirmedOptionSelected(tempCurrentOptionForConfirmation);
																		setTempCurrentOptionForConfirmation(null);
																 }}
								  />
						}
				 </>
	  );
}